exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home__logo-container {\n  float: left;\n}\n.home__logo {\n  width: 100%;\n  max-width: 640px;\n}\n.home .home__logout {\n  float: right;\n  line-height: 80px;\n}\n", ""]);

// exports
